import useMutation from 'use-mutation'
import { post } from './api'
import { DamageReport, NewDamageReport } from './types'

const createDamageReport = ({
  damageReport,
}: {
  damageReport: NewDamageReport
}) => post<DamageReport>('/damage_reports', damageReport)

export const useCreateDamageReport = () => useMutation(createDamageReport)
